import { forEach, get, set } from 'lodash';

import { THEME_DEFAULTS, AGENT_DATA_TO_THEME_PATH_MAP } from 'common/constants/theme';

const themeAgent = (theme, customizations) => {
  forEach(Object.keys(AGENT_DATA_TO_THEME_PATH_MAP), key => {
    const path = AGENT_DATA_TO_THEME_PATH_MAP[key];
    if (key in customizations) {
      const value = customizations[key] == null ? get(THEME_DEFAULTS, path) : customizations[key];
      set(theme, path, value);
    } else {
      set(theme, path, get(THEME_DEFAULTS, path));
    }
  });
  return theme;
};

export { themeAgent };
